import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { Button, Container, Row, Col, InputGroup, FormControl, Tabs, Tab, Spinner } from "react-bootstrap";
import { ContentHeader, ContentBody } from "./styles"
import { FaFolder, FaSearch } from "react-icons/fa";
import { WithdrawalTable } from "../../../../components/table-withdrawal";
import { PaginationList } from "../../../../../../components/pagination";
import { Modal } from "../../../../../../components/modal";

import { getWithdrawls, getOpenedWithdrawls, getFinishedWithdrawls } from "../../../../../../services/manager/partner/withdrawl.service";

export const ListWithdrawal = (): JSX.Element => {
    const { t: translation } = useTranslation();
    const history = useHistory();

    //Pagination
    const [totalItens, setTotalItens] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    //Ordering and searching
    const [query, setQuery] = useState("");
    const [sortOrder, setSortOrder] = useState(1);
    const [sortField, setSortField] = useState("name");
    
    const [invoice, setInvoice] = useState("")
    const [showInvoice, setShowInvoice] = useState<boolean>(false)
    const [voucher, setVoucher] = useState("")
    const [showVoucher, setShowVoucher] = useState<boolean>(false)
    const [showEmptyMessage, setShowEmptyMessage] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [cleanQueryField, setCleanQueryField] = useState<boolean>(false);
    const [key, setKey] = useState<string>("all");
    const [withdrawalList, setWithdrawalList] = useState([]);
    const [openedList, seOpenedList] = useState([]);
    const [finishedList, setFinishedList] = useState([]);

    const handleChangeTab = (k: string) => {
        setCleanQueryField(true)
        setQuery("");
        switch (k) {
          case 'opened':
            getOpenedList();
          break;
    
          case 'finished':
            getFinishedList();
          break;
          
          default:
            getWithdrawalList();
        }  
        setKey(k)
    }

    const handleTableSort = useCallback((event: any) => {
        let order = event.sortOrder > 0 ? event.sortField : '-' + event.sortField;
        
        setSortOrder(event.sortOrder);
        setSortField(event.sortField);
    
        switch (key) {
          case 'opened':
            getOpenedList(`ordering=${order}`);
          break;
    
          case 'finished':
            getFinishedList(`ordering=${order}`);
          break;
          
          default:
            getWithdrawalList(`ordering=${order}`)
        }
    }, []);
    
    const handlePageChange = (event?: any) => {
    if (currentPage !== event) {
        switch (key) {
        case 'opened':
            getOpenedList(`page=${event}&q=${query}`);
        break;

        case 'finished':
            getFinishedList(`page=${event}&q=${query}`);
        break;
        
        default:
            getWithdrawalList(`page=${event}&q=${query}`)
        }
        setCurrentPage(event)
    }
    }

    const getWithdrawalList = (_query?: string) => {
        setLoading(true)
        getWithdrawls(_query).then(data => {
            if (data.results.length === 0) {
                setShowEmptyMessage(true)
            } else {
                setShowEmptyMessage(false)
            }
            setWithdrawalList(data.results);
            setTotalItens(data.count);
            setLoading(false);
        })
    }

    const getOpenedList = (_query?: string) => {
        setLoading(true)
        getOpenedWithdrawls(_query).then(data => {
            if (data.results.length === 0) {
                setShowEmptyMessage(true)
            } else {
                setShowEmptyMessage(false)
            }
            seOpenedList(data.results);
            setTotalItens(data.count);
            setLoading(false);
        })
    }

    const getFinishedList = (_query?: string) => {
        setLoading(true)
        getFinishedWithdrawls(_query).then(data => {
            if (data.results.length === 0) {
                setShowEmptyMessage(true)
            } else {
                setShowEmptyMessage(false)
            }
            setFinishedList(data.results);
            setTotalItens(data.count);
            setLoading(false);
        })
    }

    const handleShowInvoice = (node: any) => {
        setShowInvoice(true)
        if (node.files.length > 0) {
            node.files.map((item: any) => {
            if (item.type === "Nota Fiscal") {
                setInvoice(item.file)
            }
            })
        }
    }

    const handleShowVoucher = (node: any) => {
        setShowVoucher(true)
        if (node.files.length > 0) {
            node.files.map((item: any) => {
            if (item.type === "Comprovante de Pagamento") {
                setVoucher(item.file)
            }
            })
        }
    }

    const treeTableConfig = [
        {field: 'id', header: 'Código', sortable: true, style: {textAlign: 'center'}},
        {field: 'account_bank', header: 'Conta',  accountTemplate: true, sortable: true, style: {textAlign: 'left', width: '45%' }},
        {field: 'request_date', header: 'Data de Solicitação', dateTemplate: true, sortable: true, style: {textAlign: 'center'}},
        {field: 'completion_date', header: 'Data de Finalização', finishDateTemplate: true, sortable: true, style: {textAlign: 'center'}}, 
        {field: 'value', header: 'Valor em R$', valueTemplate: true, sortable: true, style: {textAlign: 'center', width: '16%'}},
        {field: '', header: 'Anexos', actionsTemplate: true, sortable: false, style: {textAlign: 'center', width: '5%'}},
      ]

    useEffect(() => {
        setLoading(false)
        getWithdrawalList()
      }, [])
    
      useEffect(() => {
        if (!cleanQueryField) {
          const timeOutId = setTimeout(() => {
            switch (key) {
              case 'opened':
                getOpenedList(`q=${query}`);
              break;
    
              case 'finished':
                getFinishedList(`q=${query}`);
              break;
              
              default:
                getWithdrawalList(`q=${query}`)
            }
          }, 500);
          return () => clearTimeout(timeOutId);
        } else {
          setCleanQueryField(false)
        }
      }, [query]);

    return (
        <Container fluid>
            <ContentHeader>
                <Row>
                    <Col>
                        <div className="title">
                            {translation('manager.withdrawal.withdrawals')}
                        </div>
                    </Col>
                    <Col className="text-end">                        
                        <Button className="mb-1" onClick={() => history.push('/manager/partner/new-withdrawal')}>{translation('manager.withdrawal.request')}</Button>
                    </Col>
                </Row>
            </ContentHeader>
            <ContentBody>
                <Row className="mt-4">
                    <Col xs={12} md={5}>
                        <InputGroup className="mb-2 mt-sm-0 ds-input-group">
                            <InputGroup.Text id="basic-addon1"><FaSearch/></InputGroup.Text>
                            <FormControl
                                className="input-text"
                                placeholder={translation('search')}
                                aria-label={translation('search')}
                                aria-describedby="basic-addon1"
                                value={query}
                                onChange={(event: any) => setQuery(event.target.value)}
                            />
                        </InputGroup>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <div id="tabs-materials">
                        <Tabs className="tabs mb-3" activeKey={key} onSelect={(k: any) => handleChangeTab(k)}>
                            <Tab eventKey="all" title={translation('manager.withdrawal.all')}>
                                {
                                    loading ? (
                                        <div className="loading-container mt-5">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    ) : (
                                        <>
                                            {
                                                showEmptyMessage ? (
                                                    <div className="text-center text-grey mt-5">
                                                        <FaFolder className="mt-5" size={100} />
                                                        <h5>{translation("manager.withdrawal.emptyWithdrawal")}</h5>
                                                    </div>
                                                ) : (
                                                    <WithdrawalTable 
                                                        treeFields={treeTableConfig} 
                                                        nodes={withdrawalList}
                                                        sortField={sortField} 
                                                        sortOrder={sortOrder}
                                                        handleTableSort={handleTableSort}
                                                        handleShowInvoice={handleShowInvoice}
                                                        handleShowVoucher={handleShowVoucher}
                                                    />
                                                )
                                            }
                                        </>
                                    )
                                }
                            </Tab>
                            <Tab eventKey="opened" title={translation('manager.withdrawal.opened')}>
                                {
                                    loading ? (
                                        <div className="loading-container mt-5">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    ) : (
                                        <>
                                            {
                                                showEmptyMessage ? (
                                                    <div className="text-center text-grey mt-5">
                                                        <FaFolder className="mt-5" size={100} />
                                                        <h5>{translation("manager.withdrawal.emptyWithdrawal")}</h5>
                                                    </div>
                                                ) : (
                                                    <WithdrawalTable 
                                                        treeFields={treeTableConfig} 
                                                        nodes={openedList}
                                                        sortField={sortField} 
                                                        sortOrder={sortOrder}
                                                        handleTableSort={handleTableSort} 
                                                        handleShowInvoice={handleShowInvoice}
                                                        handleShowVoucher={handleShowVoucher}
                                                    />
                                                )
                                            }
                                        </>
                                    )
                                }
                            </Tab>
                            <Tab eventKey="finished" title={translation('manager.withdrawal.finished')}>
                                {
                                    loading ? (
                                        <div className="loading-container mt-5">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    ) : (
                                        <>
                                            {
                                                showEmptyMessage ? (
                                                    <div className="text-center text-grey mt-5">
                                                        <FaFolder className="mt-5" size={100} />
                                                        <h5>{translation("manager.withdrawal.emptyWithdrawal")}</h5>
                                                    </div>
                                                ) : (
                                                    <WithdrawalTable 
                                                        treeFields={treeTableConfig} 
                                                        nodes={finishedList}
                                                        sortField={sortField} 
                                                        sortOrder={sortOrder}
                                                        handleTableSort={handleTableSort} 
                                                        handleShowInvoice={handleShowInvoice}
                                                        handleShowVoucher={handleShowVoucher}
                                                    />
                                                )
                                            }
                                        </>
                                    )
                                }
                            </Tab>
                        </Tabs>
                    </div>
                </Row>

                {
                    !showEmptyMessage &&
                    <Row className="mt-5">
                        <PaginationList currentPage={currentPage} totalItems={totalItens} onPageChange={handlePageChange} />
                    </Row>
                }
            </ContentBody>

            <Modal headerTitle={translation('manager.withdrawal.viewInvoice')} variant="form-modal-default" show={showInvoice} loading={false} onHide={() => setShowInvoice(false)}>
                {
                    invoice ? (
                        <img width="100%" height="100%" src={invoice} alt="" />
                    ) : (
                        <h5 className="text-center">Não foi anexada uma nota fiscal</h5>
                    )
                }
            </Modal>

            <Modal headerTitle={translation('manager.withdrawal.viewVoucher')} variant="form-modal-default" show={showVoucher} loading={false} onHide={() => setShowVoucher(false)}>
                {
                    voucher ? (
                        <img width="100%" height="100%" src={voucher} alt="" />
                    ) : (
                        <h5 className="text-center">Não foi anexado nenhum comprovante</h5>
                    )
                }
            </Modal>
        </Container>
    )
}